export default __webpack_public_path__ + "static/second-663d4efa88df96bf5bace52d4c3b926b.jpg";